import { render } from "./Error.vue?vue&type=template&id=000445f2"
const script = {}
script.render = render

export default script